import { Component, OnDestroy, OnInit, signal, ViewChild, WritableSignal } from '@angular/core';
import { FormControl, FormGroup, Validators,AbstractControl, ValidationErrors } from '@angular/forms';
import { SettingsService } from 'src/app/services/settings.service';
import { MessageService } from 'primeng/api';
import * as locationsList from '../../../assets/Json/locationsList.json'
import { LoginService } from 'src/app/services/login.service';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { RoleServicesService } from 'src/app/services/role-services.service';
import { Router } from '@angular/router';
import { JobServicesService } from 'src/app/services/job-services.service';
import { first, Subject, takeUntil } from 'rxjs';
import { SharedServicesService } from 'src/app/services/shared-services.service';

type AccountTabs = "personal-settings" | "roles-permission-settings";
export type SubPermissionGroupPermission = { display_name: string, id: number, slug_name: string, slug: string, isChecked: boolean, name: string };
export type SubPermissionGroup = {
  label: string,
  slug: string,
  value: { id: number, name: string, slug: string, isChecked: boolean, isDisabled: boolean }[],
  permissions: SubPermissionGroupPermission[],
  isSelectedAll: boolean,
  active: boolean
}
export type PermissionGroups = {
  label: string,
  icon: string,
  slugs: string[],
  active: boolean,
  subgroups: SubPermissionGroup[]
}
export const manageEventsSlugs = ["event_interviews", "event_types", "event_candidate_bulk_actions", "event_candidate", "event_stage_rules", "events", "event_stage_level_access", "event_roles", "event_stages", "event_categories"]
export const manageCandidatesSlugs = ["candidate_source/types", "candidates"]
export const manageJobRoelsSlugs = ["job_roles", "role_types"];

@Component({
    selector: 'app-primary-account',
    templateUrl: './primary-account.component.html',
    styleUrls: ['./primary-account.component.css'],
    providers: [MessageService],
    standalone: false
})
export class PrimaryAccountComponent implements OnInit, OnDestroy {
  unsub$: Subject<void> = new Subject<void>();

  permissionGroups: PermissionGroups[] = [
    { label: "Events", icon: "pi pi-calendar", slugs: manageEventsSlugs, active: true, subgroups: [] },
    { label: "Candidates", icon: "pi pi-users", slugs: manageCandidatesSlugs, active: false, subgroups: [] },
    { label: "Job Roles", icon: "pi pi-clone", slugs: manageJobRoelsSlugs, active: false, subgroups: [] },
    { label: "Settings", icon: "pi pi-cog", slugs: [], active: false, subgroups: [] },
  ]

  userName: any;
  userRole: any;
  userPrivileges: Set<string> = new Set();
  addTemplateSidebar: boolean = false;
  userInfo: any = [];
  branchData: any = [];
  currentEmailData: any = [];
  newEmailData: any = [];
  userDetails: any = [];
  module_slug_list: any = [];
  _module_slug_list: any = [];
  moduleList: any = [];
  showPlaceholder: boolean = false;
  _templateTitle: string = '';
  saveBtnLoading: boolean = false;
  showOtpField: boolean = false;
  verifiedMail: boolean = false;
  isLoading: boolean = true;
  selectedModule: string = '';
  emailForm: FormGroup = new FormGroup({
    oldEmail: new FormControl('', Validators.email),
    newEmail: new FormControl('', Validators.email),
    Otp: new FormControl(),
    emailChange: new FormControl()
  })

  passwordForm: FormGroup = new FormGroup({
    currentPassword: new FormControl('',Validators.required),
    newPassword: new FormControl('',[Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/)]),
    confirmPassword: new FormControl('',Validators.required)
  }, { validators: this.passwordMatchValidator })

  otpTimer: WritableSignal<number> = signal<number>(60);
  otpCountdown: WritableSignal<string> = signal<string>("");
  otpIntervalId: any = null;

  passwordMatchValidator(control: AbstractControl): ValidationErrors | null {
    const formGroup = control as FormGroup;
    const newPassword = formGroup.get('newPassword')?.value;
    const confirmPassword = formGroup.get('confirmPassword')?.value;

    if (newPassword === confirmPassword) {
      return null;
    } else {
      formGroup.get('confirmPassword')?.setErrors({ mismatch: true });
      return { mismatch: true };
    }
  }

  accountDetails: FormGroup = new FormGroup({
    email: new FormControl(),
    password: new FormControl(),
    mobile: new FormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]{10}$')
    ]),
    primaryLocation: new FormControl(),
  })

  personalDetails: FormGroup = new FormGroup({
    first_name: new FormControl('', [Validators.required]),
    last_name: new FormControl('', [Validators.required]),
    mobile_number: new FormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]{10}$')
    ]),
  })

  sidebarAction: string = '';
  sideActionIcon: string = '';
  otp: string = '';
  emailEdit: string = '';
  passwordEdit: string = '';

  verifiedCurrentEmail: boolean = true;
  currentPassShow: boolean = false;
  newPassShow: boolean = false;
  confirmPassShow: boolean = false;
  clicked: boolean = false;

  passwordMessage: string = '';
  primaryLocation: string = '';
  userId:string='';
  roleId:string = '';
  primaryLocationList: any = (locationsList as any).default;

  passwordLevel = {
    hasMinLength: false,
    hasSpecialCharacter: false,
    hasUpperCase: false,
    level: 0
  }

  constructor(private settings: SettingsService, private messageService: MessageService, private loginService: LoginService, private settingService: SettingsService, private globalService: GlobalServicesService,private roleService: RoleServicesService,private router: Router,private jobServices: JobServicesService, private sharedService: SharedServicesService) { }

  ngOnInit(): void {
    this.globalService.userMeta$.subscribe(meta => {
      this.userRole = meta?.role_details || '';
      this.userName = meta?.user_profile || {};    
      this.userId = this.userName?.id || '';
      this.getAccountData(this.userName);
      this.roleId=this.userRole?.id || '';

      this.personalDetails.get("mobile_number")?.setValue(this.userName.mobile_number);
      this.personalDetails.get("first_name")?.setValue(this.userName.first_name);
      this.personalDetails.get("last_name")?.setValue(this.userName.last_name);
    });
    
    
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
    this.roleAndPermissionFormData();

    this.passwordForm.get("newPassword")?.valueChanges.pipe(takeUntil(this.unsub$)).subscribe((val) => {
      const hasMinLength = val.length >= 8;
      const hasSpecialCharacter = /[!@#$%^&*%]/.test(val);
      const hasUpperCase = /[A-Z]/.test(val);
      const level = [hasMinLength, hasSpecialCharacter, hasUpperCase].filter(Boolean).length;

      this.passwordLevel = {
        hasMinLength,
        hasSpecialCharacter,
        hasUpperCase,
        level
      };
    })
  }

  ngOnDestroy(): void {
    this.unsub$.next();
    this.unsub$.complete();
  }
  
  roleAndPermissionFormData() {
    this.isLoading = true;
    this.roleService.getRoleAndPermissionFormDataFastApi().subscribe({
      next: (res: any) => {
        this.isLoading = false;
        const permissionsData = res.body;   
        this.module_slug_list = [];
        permissionsData.forEach((group: any) => {
          const module = {
            label: group.group, 
            slug: group.group.toLowerCase().replace(/\s/g, '_'), 
            value: group.permissions.map((permission: any) => ({
              id: permission.id,
              name: permission.display_name,
              slug: permission.slug_name, 
              isChecked: this.userPrivileges.has(permission.slug_name), 
              isDisabled: false 
            })),
            permissions: group.permissions, 
            isSelectedAll: false 
          };
  
          this.module_slug_list.push(module);
        });  
        this._module_slug_list = this.module_slug_list;

        this.initializePermissionGroups();
      },
      error: (error: any) => {
        this.isLoading = false;
        this.globalService.commonGrowl.next({ severity: 'error', summary: 'Error', detail: error.message });
      }
    });
  }  

  getAccountData(userProfile?: any) {
    this.isLoading = true;
    const userDetails = userProfile || {};
    this.userInfo = [
      { field: "Email/Username", value: userDetails.email ?? '--' },
      { field: "Password", value: '**********' },
      { field: "Phone/Mobile", value: userDetails.mobile_number ?? '--' },
    ]
    this.isLoading = false;
    return true;
  }  

  openAddTemplate(template: string, icon: string) {
    this.sidebarAction = template;
    this.accountDetails.get('email')?.disable();
    this.accountDetails.get('password')?.disable();
    this.sideActionIcon = icon;
    this.addTemplateSidebar = true;
    this.emailEdit = this.userInfo[0]?.value;
    this.passwordEdit = this.userInfo[1]?.value;    
    const mobileNumber = this.userInfo.find((info: any) => info.field === "Phone/Mobile")?.value;
    this.verifiedMail = false;
    this.showOtpField = false;
    this.currentPassShow = false;
    this.confirmPassShow = false;
    if (mobileNumber && mobileNumber !== '--') {
      this.accountDetails.get('mobile')?.setValue(mobileNumber);
    } else {
      this.accountDetails.get('mobile')?.setValue(null);
    }
    this.primaryLocation = this.userInfo[3]?.value;

    if(template === "Change Email") {
      this.emailForm.get("oldEmail")?.setValue(this.userName.email)
    }
  }

  saveTemplateNew() {
    if(!this.personalDetails.dirty) {
      this.messageService.add({ 
        severity: 'warn', 
        summary: 'No Changes Detected', 
        detail: 'You haven\'t made any changes to the form. Please update at least one field before submitting.' 
      });
      return;
    }

    const fieldsToCheck = ['first_name', 'last_name', 'email', 'mobile_number'];
    if (this.sharedService.hasSecurityViolations(this.personalDetails, fieldsToCheck)) {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Invalid Input', 
        detail: 'Invalid input format in some fields.' 
      });
      this.saveBtnLoading = false;
      return;
    }

    const mobileControl = this.personalDetails.get('mobile_number');
    if (!mobileControl?.value) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please enter mobile number'
      });
      return;
    }

    this.personalDetails.markAllAsTouched();
    this.personalDetails.updateValueAndValidity();
    if (this.personalDetails.invalid) {
      return;
    }

    this.saveBtnLoading = true;
    let payload = {
      ...this.sharedService.getSecurePayload(this.personalDetails.value),
      email: this.userName.email,
      role_id: this.roleId
    };
    this.jobServices.updateUserFastApi(payload, this.userId).subscribe((res: any) => {
      if (res.status == 200) {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Saved Successfully', });
        this.personalDetails.get("first_name")?.markAsUntouched();
        this.personalDetails.get("last_name")?.markAsUntouched();
        this.personalDetails.get("mobile_number")?.markAsUntouched();
        setTimeout(() => {
          this.addTemplateSidebar = false;
          this.getAccountData(this.userName);
        }, 1000)
      }
      else {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Something went Wrong!', })
      }
      this.saveBtnLoading = false;
    }, (err) => {
      this.saveBtnLoading = false;
    });
  }


saveTemplate = () => {
  const mobileControl = this.accountDetails.get('mobile');
  if (!mobileControl?.value) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warning',
      detail: 'Please enter mobile number'
    });
    this.saveBtnLoading = false;
    return;
  }
  if (mobileControl.errors) {
    this.messageService.add({
      severity: 'error',
      summary: 'Failed',
      detail: 'Please enter a valid 10-digit mobile number'
    });
    this.saveBtnLoading = false;
    return;
  }
  let payload = {
    first_name: this.userName.first_name,
    last_name: this.userName.last_name,
    mobile_number: String(mobileControl.value),
    email: this.userName.email,
    role_id: this.roleId,
  };
  this.jobServices.updateUserFastApi(payload, this.userId).subscribe((res: any) => {
    if (res.status == 200) {
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Saved Successfully', });
      setTimeout(() => {
        this.addTemplateSidebar = false;
        this.getAccountData(this.userName);
      }, 1000)
    }
    else {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Something went Wrong!', })
    }
    this.saveBtnLoading = false;
  });
}

  onOtpChange(e: any) {
    this.otp = e
  }

  onConfigChange() {
    this.verifiedMail = false;
    this.showOtpField = false;
    this.otp = '';
  }

  showPassword(selector: any) {
    let x: any = document.getElementsByClassName(selector)[0];
    if (!x) { return; }
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  }

  verifyEmail() {
    if (!this.emailForm.controls['newEmail'].errors) {
      let newEmail = {
        'new_email': this.emailForm.controls['newEmail'].value.toLowerCase()
      };
      this.settings.emailVerifyFastApi(newEmail).subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.verifiedMail = true;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: res.body.detail });
            this.showOtpField = true;
            this.newEmailData = res.body;
            this.startOtpTimer();
          }
        },
      });
    }
  }

  startOtpTimer() {
    this.otpTimer.set(60);
    this.otpCountdown.set(`${this.otpTimer().toString().padStart(2, '0')}`);

    if (this.otpIntervalId) {
      clearInterval(this.otpIntervalId);
    }

    this.otpIntervalId = setInterval(() => {
      this.otpTimer.update((val) => {
        const updatedVal = val - 1;
        return updatedVal;
      })
      this.otpCountdown.set(`${this.otpTimer().toString().padStart(2, '0')}`);

      if (this.otpTimer() === 0) {
        clearInterval(this.otpIntervalId);
      }
    }, 1000);
  }

  resetOTP() {
    this.otpTimer.set(60);
    clearInterval(this.otpIntervalId)
  }

  verifyOtp() {
    if(!this.otp.length) {
      return;
    }

    const newPayload = {
      new_email: this.emailForm.controls['newEmail'].value,
      otp: this.otp
    };
    this.onConfigChange();
    this.settings.emailUpdateFastApi(newPayload).subscribe({
      next: (res: any) => {
        if (res.status === 200){
          this.messageService.add({
            severity: 'success',
            summary: 'OTP Verified',
            detail: 'Redirecting to login page...',
            life: 3000
          });  
          this.emailForm.reset();
          this.addTemplateSidebar = false;
          this.sidebarAction = 'Edit Primary Account';
  
          setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
            this.router.navigate(['/login']); 
          }, 2000);
        }
      },
      error: (err: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Verification Failed',
          detail: err?.error?.detail || 'Invalid OTP or server error'
        });
      }
    });
  }  
  changePassword(){
    if(this.passwordForm.valid){
      let newPayload = {
        old_password: this.passwordForm.controls['currentPassword'].value,
        new_password: this.passwordForm.controls['newPassword'].value,
        confirm_new_password: this.passwordForm.controls['confirmPassword'].value
      }
      this.onConfigChange();
      this.settings.changePasswordFastApi(newPayload).subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.messageService.add({
              severity: 'success',
              summary: 'Password Updated',
              detail: 'Your password was changed successfully! Redirecting to login page...',
              life: 3000
            });
            this.passwordForm.reset();
            this.addTemplateSidebar = false;
      
            setTimeout(() => {
              localStorage.clear();
              sessionStorage.clear();
              this.router.navigate(['/login']); 
            }, 2000);
          }
        },
        error: (err: any) => {
          this.saveBtnLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Password Update Failed',
            detail: err?.error?.detail || 'Failed to update password. Please try again.',
            life: 5000
          });
        }
      });
      
    }else{
      this.clicked = true;
      this.passwordMessage = "Please fill all the fields correctly";
    }
  }
  getModuleSlugList(){
    this._module_slug_list = this.module_slug_list.filter((module: any) => module.slug === this.selectedModule);
  }
  toggleExpand(slug: any) {
    slug.isExpanded = !slug.isExpanded;
}

  currentTab: WritableSignal<AccountTabs> = signal<AccountTabs>("personal-settings");
  switchCurrentTab(tab: AccountTabs) {
    this.currentTab.set(tab);
  }

  initializePermissionGroups() {
    (this.module_slug_list as any[]).forEach((module_slug) => {
      const slug = module_slug.slug;
      const matchingGroup = this.permissionGroups.find(group => group.slugs.includes(slug));

      const subPermissionGroup: SubPermissionGroup = {
        ...module_slug,
        active: false
      }

      if (matchingGroup) {
        matchingGroup.subgroups.push(subPermissionGroup);
      } else {
        const fallbackGroup = this.permissionGroups.find(group => group.slugs.length === 0);
        if (fallbackGroup) {
          fallbackGroup.subgroups.push(subPermissionGroup);
        } else {
          console.warn(`No fallback group found for slug "${slug}"`);
        }
      }
    })
    this.permissionGroups.forEach((group, index) => {
      group.active = false;
      if (index === 0) group.active = true;

      if (group.active) {
        group.subgroups.forEach((subgroup, index) => {
          subgroup.active = false;
          if (index === 0) subgroup.active = true;
        })
      }
    })
  }

  changeActivePermissionGroup(group: PermissionGroups) {
    this.permissionGroups.forEach((permissionGroup) => {
      permissionGroup.active = false;

      if(permissionGroup.label === group.label) {
        permissionGroup.active = true;
      }

      permissionGroup.subgroups.forEach((subPermission, index) => {
        subPermission.active = false;
        if(permissionGroup.active && index === 0) {
          subPermission.active = true;
        }
      })
    })
  }

  changeActiveSubPermissionGroup(subGroup: SubPermissionGroup) {
    const activePermissionGroup = this.permissionGroups.find((permissionGroup) => permissionGroup.active);
    if (activePermissionGroup) {
      activePermissionGroup.subgroups.forEach((subPerGroup) => {
        subPerGroup.active = false;
        if (subPerGroup.slug === subGroup.slug) {
          subPerGroup.active = true;
        }
      })
    }
  }

  getActivePermissionsSubGroups() {
    const activePermissionGroup = this.permissionGroups.find((permission) => permission.active);
    if(activePermissionGroup) {
      return activePermissionGroup.subgroups;
    }

    return []
  }

  getActiveSubPermissionsValues() {
    const activePermissionsSubGroup = this.getActivePermissionsSubGroups();
    const activeSubPermission = activePermissionsSubGroup.find((subPermission) => subPermission.active);
    if(activeSubPermission) {
      return activeSubPermission.value;
    }

    return [];
  }
}